import * as React from 'react';

import classnames from 'classnames';

import {RemoveButton} from '../button/remove-button/remove-button';
import {Link} from '../link/link';

import styles from './select-two-line-icon.module.css';

export type RemoveButtonProps = {
    onClick: (id: string) => void;
};

type Props = {
    icon?: React.ComponentType<any>;
    iconNode?: React.ReactNode;
    label: string;
    sublabel?: string;
    isSelected?: boolean;
    shouldWrap?: boolean;
    smallLabel?: boolean;
    href?: string;
    onRemoveClick?: (e: React.SyntheticEvent<HTMLButtonElement>) => void;
};

export function IconAndLabel(props: Props) {
    const {icon, label, sublabel, shouldWrap = true, smallLabel = false} = props;
    const Icon = icon;

    const containerClass = shouldWrap ? '' : 'overflow-hidden';
    let textClass = shouldWrap ? '' : 'truncate';
    const labelTitle = shouldWrap ? undefined : label;
    const labelStyleName = smallLabel ? styles['label-small'] : styles.label;
    const sublabelTitle = shouldWrap ? undefined : sublabel;

    // Add margin to the text if there is a remove button to make space for the button
    if (props.onRemoveClick) {
        textClass += ' mr-32';
    }

    const labelElement = (
        <div title={labelTitle} className={classnames(textClass, labelStyleName)}>
            {label}
        </div>
    );

    return (
        <div className={`flex align-center ${containerClass}`}>
            <div className={`flex align-center ${containerClass} gap-8`}>
                {Icon ? (
                    <div className={styles['icon-container']}>
                        <Icon size={19} />
                    </div>
                ) : undefined}
                {props.iconNode}
                <div className={containerClass}>
                    {props.href ? (
                        <Link href={props.href} variant='secondary'>
                            {labelElement}
                        </Link>
                    ) : (
                        labelElement
                    )}
                    {sublabel && (
                        <div
                            title={sublabelTitle}
                            className={classnames(textClass, styles.sublabel)}
                        >
                            {sublabel}
                        </div>
                    )}
                </div>
            </div>
            {!props.isSelected && props.onRemoveClick && (
                <div className={styles['remove-button']}>
                    <RemoveButton size={12} variant='dark' onClick={props.onRemoveClick} />
                </div>
            )}
        </div>
    );
}
